import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  DefaultCurrencyPickListOptions,
  InvestmentAmmountPickListOption,
  InvestmentExperienceLevel,
  SalesforceAccountPayload,
} from "src/store/features/api/generated";
import {
  ApplicationStepsOptionsType,
  WealthSourceOptions,
  setFormApplicationData,
  setInvestimentExpPrefilled,
  useOnboarding,
} from "src/store/features/onboarding.slice";
import { UserState } from "src/store/features/user.slice";

const mapSalesforceToUserState = (
  salesforceData: SalesforceAccountPayload,
  applicationStep: ApplicationStepsOptionsType,
): Partial<UserState> => {
  const {
    dob,
    defaultCurrency,
    documents,
    initialInvestment,
    investmentExp,
    investmentFrequency,
    wealthSource,
    address,
    entityDetails,
    ignoreBiometrics,
    occupation,
    hearAboutUs,
    ...rest
  } = salesforceData;

  const [year, month, day] = dob.split("-");
  return {
    ...(rest as any),
    birthdate: { year, month, day },
    address: {
      ...address,
      fullAddress: address.street,
    },
    cryptoJourney: {
      defaultCurrency: defaultCurrency as DefaultCurrencyPickListOptions,
      investmentPlan: initialInvestment as InvestmentAmmountPickListOption,
      investmentExp: investmentExp as InvestmentExperienceLevel,
      frequency: investmentFrequency,
      wealthSource: wealthSource as WealthSourceOptions[],
      occupation,
      hearAboutUs,
    },
    applicationStep,
  };
};

export const usePrepopulateForm = (previousSubmission: SalesforceAccountPayload | undefined) => {
  const dispatch = useDispatch();
  const { applicationStep } = useOnboarding();

  useEffect(() => {
    if (previousSubmission) {
      const userStateData = mapSalesforceToUserState(previousSubmission, applicationStep);
      dispatch(setFormApplicationData(userStateData as any));
    }

    if (previousSubmission?.investmentExp) dispatch(setInvestimentExpPrefilled(true));
  }, [previousSubmission, dispatch]);
};
